import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'get'

export default class OspreyTemplatesSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = 'b62e81ed-9f1d-447e-b060-3a349842356b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
            archived: false,
            channel: '1,3,4'
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-search-suggestion.js